import { Fragment } from "react";
import classNames from "classnames";
import Balancer from "react-wrap-balancer";
import Image from "components/imageNew/image";
import { getDateFormattedNumeric } from "lib/utils";
import Markdown from "components/markdown/markdown";
import { BackArrowIcon } from "components/icons/icons";
import IconButton from "components/iconButton/iconButton";

const innerContainerClasses = classNames(
  "mx-auto w-100 max-w-[1040px] px-5 pb-[70px] pt-[30px] md:pt-[50px] lg:pt-[60px] lg:max-w-[1220px] lg:px-0"
);

const Separator = () => (
  <div className="mb-[14px] mt-[50px] w-100 border-b-2 border-black-rock md:mt-[60px]" />
);

const ScoutMethodologyView = ({ data }) => {
  return (
    <Fragment>
      <main className="w-100 overflow-x-hidden bg-[#F4F4F6] pt-[65px] text-black-rock">
        <div className={innerContainerClasses}>
          <div className="flex flex-col justify-between gap-y-[10px] md:flex-row md:items-center">
            <IconButton
              component={"link"}
              href="/scout"
              className="flex items-center justify-center"
            >
              <BackArrowIcon className="scale-[107%]" />
            </IconButton>
            <p className="text-[16px] text-mono-30">
              Last updated {getDateFormattedNumeric(data.lastUpdated)}
            </p>
          </div>

          <div className="mt-[10px] flex w-100 flex-col">
            <h1 className="font-recklessBold text-[32px] leading-[130%] md:text-[52px] lg:w-3/5">
              <Balancer>{data.heroTitle}</Balancer>
            </h1>
            <div className="mt-5 self-end text-[16px] leading-[130%] text-mono-30 md:text-[24px] lg:w-2/3 [&_strong]:font-normal [&_strong]:text-black-rock">
              <Markdown text={data.heroSubtitle} />
            </div>
          </div>

          <Separator />

          <h2 className="mb-5 font-bold text-[22px] leading-[130%]">
            {data.eligibilityTitle}
          </h2>

          <div className="text-[16px] [&_ol>li]:ml-5 [&_ol>li]:list-decimal">
            <Markdown text={data.eligibilityText} />
          </div>

          <Separator />
          <h2 className="mb-5 font-bold text-[22px] leading-[130%]">
            {data.evaluationTitle}
          </h2>
          <div className="flex flex-col gap-y-[30px] text-[16px]">
            {data.evaluationTextAndImage.map((entry) => {
              const { image } = entry;
              return (
                <div
                  key={entry.id}
                  className="flex flex-col gap-x-[50px] md:flex-row"
                >
                  <p className="">{entry.text}</p>
                  {image ? (
                    <Image
                      src={image.url}
                      blurDataURL={image.blurUpThumb}
                      width={image.width}
                      height={image.height}
                      alt={image.alt}
                      className={
                        "mx-auto mt-[14px] h-[216px] w-[320px] flex-shrink-0 object-cover md:mx-0 md:mt-0 md:h-[182px] md:w-[270px]"
                      }
                    />
                  ) : null}
                </div>
              );
            })}
          </div>

          <div className="my-[30px] border-b border-[#D7D7DB]"></div>

          <h2 className="mb-[14px] font-bold text-[16px]">
            {data.signalsTitle}
          </h2>
          <div className="grid grid-cols-1 gap-x-[50px] gap-y-[30px] md:grid-cols-2 lg:grid-cols-3">
            {data.signalEntry.map((entry) => {
              return (
                <div key={entry.id} className="">
                  <div className="mb-[10px] w-min-content bg-mono-30 px-[6px] py-1">
                    <p className="whitespace-nowrap text-[14px] leading-[130%] text-white">
                      {entry.singleLine}
                    </p>
                  </div>
                  <p className="text-[16px] leading-[130%]">
                    {entry.multilineText}
                  </p>
                </div>
              );
            })}
          </div>
          <Separator />
          <h2 className="mb-5 font-bold text-[22px] leading-[130%]">
            {data.sourcesTitle}
          </h2>
          <div className="text-[16px] [&_ol>li]:ml-5 [&_ol>li]:list-decimal">
            <Markdown text={data.sourcesText} />
          </div>

          <div className="mt-[60px] bg-[#E8E8EB] px-3 py-4">
            <h2 className="mb-[10px] font-bold text-[16px] leading-[130%]">
              {data.disclaimerTitle}
            </h2>
            <p className="text-[16px] leading-[130%]">{data.disclaimerText}</p>
          </div>
        </div>
      </main>
    </Fragment>
  );
};

export default ScoutMethodologyView;
